import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import QuizGradeList from './QuizGradeList';
import StudentTodaySchedule from './StudentTodaySchedule';
import StudentToDoList from './StudentToDoList';
import AssignmentGradeList from './AssignmentGradeList';
import EventGradeList from './EventGradeList';
import Agenda from './Agenda';
import StudentUnscheduledCourseList from './StudentUnscheduledCourseList';
import { Paper } from '@material-ui/core';
import InstructorTodaySchedule from './InstructorTodaySchedule';
import InstructorToDoList from './InstructorToDoList';
import CompanyLinkWidget from './CompanyLinkWidget';
import NewUsersWidget from './NewUsersWidget';
import FailedEventsWidget from './FailedEventsWidget';

const styles = theme => ({
    root: {}
});

class Widget extends Component {
    getWidgetContent = (widget_name) => {
        switch (widget_name) 
        {
            case("QuizGradeList"):
            {
                return <QuizGradeList />;
            }

            case("Agenda"):
            {
                return <Agenda />;
            }
            
            case("AssignmentGradeList"):
            {
                return <AssignmentGradeList />;
            }

            case("EventGradeList"):
            {
                return <EventGradeList />;
            }

            case("StudentTodaySchedule"):
            {
                return <StudentTodaySchedule />;
            }

            case("StudentToDoList"):
            {
                return <StudentToDoList />;
            }

            case("StudentUnscheduledCourseList"):
            {
                return <StudentUnscheduledCourseList />;
            }

            case("InstructorTodaySchedule"):
            {
                return <InstructorTodaySchedule />
            }

            case("InstructorToDoList"):
            {
                return <InstructorToDoList />
            }
            case("CompanyLinkWidget"):
            {
                return <CompanyLinkWidget />
            }
            case("NewUsersWidget"):
            {
                return <NewUsersWidget />
            }
            case("FailedEventsWidget"):
            {
                return <FailedEventsWidget />
            }
            default:
            {
                return <React.Fragment>Widget Example</React.Fragment>;
            }
        }
    }
    
    render() {
        const { widget_name } = this.props;
        
        return (
            <Paper style={{width:"100%", height:"100%", overflow: 'auto'}}>
                {this.getWidgetContent(widget_name)}
            </Paper>
        );
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(Widget));



// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/Widget.js